import { getJson } from './baseApi'

export const fetchRequestInfo = () => {
	return getJson('/api/oauth/requestinfo')
}